import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { AssessmentTestDefinitionSchema, CreateCmsAssessmentTestRequestSchema, UpdateCmsAssessmentTestRequestSchema, } from './assessment-test';
export const createCmsAssessmentTestRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/cms/assessment-tests',
    name: 'create-cms-assessment-test',
    request: { body: CreateCmsAssessmentTestRequestSchema },
    responses: {
        200: AssessmentTestDefinitionSchema,
        201: AssessmentTestDefinitionSchema,
        400: HttpErrorResponse,
        409: HttpErrorResponse,
    },
};
export const updateCmsAssessmentTestRoute = {
    version: 1,
    method: 'PUT',
    path: '/admin/cms/assessment-tests/{slug}',
    name: 'update-cms-assessment-test',
    request: {
        params: z.object({ slug: z.string().min(1) }),
        body: UpdateCmsAssessmentTestRequestSchema,
    },
    responses: {
        200: AssessmentTestDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
